import axios from "axios";
import axiosInstance from "./axiosInstance";

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchClients = async () => {
  try {
    const response = await axios.get(`${apiUrl}/clients`);
    return response;
  } catch (error) {
    console.error("Erreur lors de la récupération des clients : ", error);
    throw error;
  }
};

export const fetchClientById = async (clientId) => {
  try {
    const response = await axios.get(`${apiUrl}/clients/${clientId}`);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération du client : ", error);
    throw error;
  }
};

export const fetchClientAppointments = async (clientId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/clients/${clientId}/appointments`,
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération du client : ", error);
    throw error;
  }
};

export const fetchClientStats = async (clientId) => {
  try {
    const response = await axios.get(`${apiUrl}/clients/${clientId}/stats`);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération du client : ", error);
    throw error;
  }
};

export const sendClientEmail = async (clientId, payload) => {
  try {
    const response = await axiosInstance.post(
      `/clients/${clientId}/send-email`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'envoi du mail au client : ", error);
    throw error;
  }
};

export const createClient = async (values) => {
  try {
    const response = await axiosInstance.post("/clients", values);
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || "Une erreur est survenue.";
    console.error("Erreur lors de la création du client : ", message);
    throw error;
  }
};

export const updateClient = async (id, values) => {
  try {
    const response = await axiosInstance.patch(`/clients/${id}`, values);
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || "Une erreur est survenue.";
    console.error("Erreur lors de la mise à jour du client : ", message);
    throw error;
  }
};

export const deleteClient = async (clientId) => {
  try {
    const response = await axiosInstance.delete(`/clients/${clientId}`);
    return response.data;
  } catch (error) {
    const message = error.response?.data?.message || "Une erreur est survenue.";
    console.error("Erreur lors de la suppression du client : ", message);
    throw error;
  }
};
